import { memo } from 'react';

import { FieldTableGenericExtends } from '../FieldTable/types/FieldTableGenericExtends';
import { isFieldWithConditionalVisibility } from './logic/isFieldWithConditionalVisibility';
import { OptionalFieldVisibilityProps } from './types/OptionalFieldVisibilityProps';
import { FieldVisibility } from './FieldVisibility';

// Mirrors `OptionallyDisplayWhen`: only fields that actually declare a
// condition subscribe to form changes via `useWatch`; everything else renders
// straight through with no subscription and no re-renders.
const OptionalFieldVisibilityComponent = <D extends FieldTableGenericExtends>({
  field,
  children,
}: OptionalFieldVisibilityProps<D>) => {
  if (!isFieldWithConditionalVisibility(field)) {
    return <>{children}</>;
  }

  return <FieldVisibility field={field}>{children}</FieldVisibility>;
};

export const OptionalFieldVisibility = memo(OptionalFieldVisibilityComponent);
